import { ContentBlock, Icon } from "@gplibraries/react/components";
import { useLogger, useConfig } from "@gplibraries/react/hooks";
import {useMutation} from "@tanstack/react-query";
import { clearApiCache } from "../../../api/cache";

interface PrimaryContactProps {
  token: any;
}

export default function AdminBlock({ token }: PrimaryContactProps) {

  const logger = useLogger();
  const { dealerAccessApiHost } = useConfig();

  const { isPending: cacheClearLoding, mutate: clearCache } = useMutation({
    mutationFn: async (cache: string) => clearApiCache(dealerAccessApiHost, token.accessToken, cache),
    onError: (err) => {
      logger.error(err, {
        source: 'AdminBlock',
        action: 'clear-cache',
        alert: true,
      })
      alert('An error occurred while attempting to clear the cache.');
    },
    onSuccess: () => alert('Cache cleared successfully.')
  })

  return (
    <ContentBlock title={'Administration'} icon={<Icon glyph={'person-fill-lock'}/>}>
      {Boolean(token) && <span>
        <Icon glyph={'arrow-repeat'}/> <button className={'hyperlink text-only'} disabled={cacheClearLoding} onClick={() => clearCache('dealer_info')}>Clear Dealer Info Cache</button>
      </span>}
    </ContentBlock>
  );
}